export const getContextMenuItems = () => [
	{ title: { desc: 8970, name: 'Expand All' }, itemIndex: 'expand' },
	{ title: { desc: 8971, name: 'Collapse All' }, itemIndex: 'collapse' }
];

export const getHideableLayoutFunc = (layoutTargets) => ({
	type: 'set',
	targets: layoutTargets
});
